<aside
  id="app-sidebar"
  [ngClass]="{
    'w-16': isCollapsed,
    'w-64': !isCollapsed,
    'invisible -translate-x-full': (sidebarOpen$ | async) === false,
    'translate-x-0': (sidebarOpen$ | async)
  }"
  class="fixed inset-y-0 left-0 z-50 flex h-dvh shrink-0 flex-col border-r border-neutral-gray30 bg-neutral-white pl-[env(safe-area-inset-left)] shadow-lg transition-[transform,visibility,width] duration-300 lg:visible lg:static lg:z-auto lg:h-full lg:translate-x-0 lg:shadow-sm">
  <div class="flex items-center justify-between px-4 py-6">
    @if (!isCollapsed) {
    <img src="assets/images/logo.svg" alt="Cardio Explorer" width="175" height="40" />
    }
    <button
      type="button"
      (click)="closeSidebar()"
      [attr.aria-label]="'shared.components.sidebar.close' | translate"
      class="-mr-1 flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-neutral-gray70 hover:bg-neutral-gray20 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-90 lg:hidden">
      <i class="pi pi-times text-lg" aria-hidden="true"></i>
    </button>
  </div>

  <nav class="flex min-h-0 flex-1 flex-col overflow-y-auto pb-[env(safe-area-inset-bottom)]">
    <ul class="space-y-1">
      @for (item of navItems; track item) {
      <li>
        @if (!item.clinicalOnly || (isAdminMode$ | async) === false) {
        <a
          [routerLink]="
            item.label === 'shared.components.sidebar.nav.test_results'
              ? testResultsRoute(isAdminMode$ | async)
              : item.route
          "
          routerLinkActive="bg-neutral-gray20 text-neutral-gray70"
          class="mx-auto flex min-h-11 w-[90%] items-center gap-3 rounded-lg px-4 py-3 text-neutral-gray70 transition hover:bg-neutral-gray20">
          <img [src]="item.icon" alt="" aria-hidden="true" class="h-5 w-5 shrink-0" />
          @if (!isCollapsed) {
          <span class="text-sm font-medium leading-none">{{
            (item.label === 'shared.components.sidebar.nav.test_results'
              ? testResultsLabel(isAdminMode$ | async)
              : item.label
            ) | translate
          }}</span>
          }
        </a>
        }
      </li>
      } @if ((isAdminMode$ | async) && (isSuperUser$ | async)) { @for (item of adminNavItems; track item) {
      <li>
        <a
          [routerLink]="item.route"
          routerLinkActive="bg-neutral-gray20 text-neutral-gray70"
          class="mx-auto flex min-h-11 w-[90%] items-center gap-3 rounded-lg px-4 py-3 text-neutral-gray70 transition hover:bg-neutral-gray20">
          <img [src]="item.icon" alt="" aria-hidden="true" class="h-5 w-5 shrink-0" />
          @if (!isCollapsed) {
          <span class="text-sm font-medium leading-none">{{ item.label | translate }}</span>
          }
        </a>
      </li>
      } }
    </ul>

    <div class="flex-grow"></div>
    <hr class="mx-auto my-4 w-[85%] rounded-lg border-[1px] border-neutral-gray30" />
    @if (isSuperUser$ | async) {
    <div class="mb-2">
      <app-mode-switcher />
    </div>
    }
    <ul class="mb-6 space-y-1">
      @for (item of secondaryNavItems; track item) { @if (!item.clinicalOnly || (isAdminMode$ | async) === false) {
      <li>
        @if (!item.isExternal) {
        <a
          [routerLink]="
            item.label === 'shared.components.sidebar.nav.settings' ? settingsRoute(isAdminMode$ | async) : null
          "
          routerLinkActive="bg-neutral-gray20 text-neutral-gray70"
          class="mx-auto flex min-h-11 w-[90%] items-center gap-3 rounded-lg px-4 py-3 text-neutral-gray70 transition hover:bg-neutral-gray20">
          <img [src]="item.icon" alt="" aria-hidden="true" class="h-5 w-5 shrink-0" />
          @if (!isCollapsed) {
          <span class="text-sm font-medium leading-none">{{ item.label | translate }}</span>
          }
        </a>
        } @if (item.isExternal) {
        <a
          [href]="getExplorisHealthUrl(item.route)"
          target="_blank"
          rel="noopener noreferrer"
          class="mx-auto flex min-h-11 w-[90%] items-center gap-3 rounded-lg px-4 py-3 text-neutral-gray70 transition hover:bg-neutral-gray20">
          <img [src]="item.icon" alt="" aria-hidden="true" class="h-5 w-5 shrink-0" />
          @if (!isCollapsed) {
          <span class="text-sm font-medium leading-none">{{ item.label | translate }}</span>
          }
        </a>
        }
      </li>
      } }
    </ul>
  </nav>
</aside>
